import keyMirror from "keymirror";

export default keyMirror({
  INIT_NEW_SETTINGS_FOR_SCHEUDLE: null,
  CREATE_SCHEDULER_SUCCESS: null,
  SCHEDULER_FAIL: null,
  LIST_SCHEDULER_SUCCESS: null,
  SET_SCHEDULER: null,
});